import { render, staticRenderFns } from "./ButtonFixedWidth.vue?vue&type=template&id=745f519c&"
import script from "./ButtonFixedWidth.vue?vue&type=script&lang=js&"
export * from "./ButtonFixedWidth.vue?vue&type=script&lang=js&"
import style0 from "./ButtonFixedWidth.vue?vue&type=style&index=0&id=745f519c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports